import { render, staticRenderFns } from "./CircularLoader.vue?vue&type=template&id=406161f1&scoped=true&"
import script from "./CircularLoader.vue?vue&type=script&lang=js&"
export * from "./CircularLoader.vue?vue&type=script&lang=js&"
import style0 from "./CircularLoader.vue?vue&type=style&index=0&id=406161f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406161f1",
  null
  
)

export default component.exports